import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { client } from './net/client';
import { applyInitialTheme } from './lib/settings';
import { useLang } from './i18n';
import { App } from './ui/App';
import './styles.css';
import './pages.css';

/** Смена языка перерисовывает приложение целиком; состояние игры живёт в client и не теряется. */
function Root() {
  const lang = useLang();
  return <App key={lang} />;
}

applyInitialTheme();
client.connect();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
